import React, { FC } from 'react';
import { LanguageModal as LanguageModalUDL } from './LanguageModal';
import { LanguageModal as LanguageModalLegacy } from './LanguageModal.Legacy';
import { LanguageModelProps } from './types';

export const LanguageModal: FC<LanguageModelProps> = props => {
  if (props.renderAsLegacy || (props.chakra && props.chakra === 'off')) {
    return <LanguageModalLegacy {...props} />;
  }
  return <LanguageModalUDL {...props} />;
};
